import { DateTime } from "luxon";

/**
 * Calculate the number of days before departure
 *
 * @param futureDateString The future date string in ISO format
 * @returns The number of days before departure. If the future date is in the past, or the future date is invalid, return -1.
 */
export function calculateDaysBeforeDeparture(futureDateString: string): number {
  const futureDate = DateTime.fromISO(futureDateString);
  if (!futureDate.isValid) {
    return -1;
  }
  const today = DateTime.local();
  if (futureDate <= today) {
    return -1;
  }
  return Math.floor(futureDate.diff(today, "days").toObject().days ?? -1);
}

export const formatDate = (isoDate: string, locale: string): string => {
  return DateTime.fromISO(isoDate).setLocale(locale).toFormat("DD");
};

/**
 * Convert the input month format: `MM/YYYY` to the format: `yyyy-MM`
 *
 * @param tripMonth expected format: `MM/YYYY`
 * @returns the converted format: `yyyy-MM` or an empty string if the input is invalid
 */
export function yearMonthConverter(tripMonth: string): string {
  let dateTime: DateTime | null = null;

  if (tripMonth?.includes("/")) {
    // Assumes format MM/YYYY
    const [month, year] = tripMonth.split("/").map(Number);
    dateTime = DateTime.fromObject({ year, month });
  } else if (tripMonth?.includes("-")) {
    // Assumes format yyyy-MM, directly parse
    dateTime = DateTime.fromISO(tripMonth);
  }
  return dateTime?.isValid ? dateTime.toFormat("yyyy-MM") : "";
}
